import { Card, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const CardSummaryGpa = ({ amount }: { amount: number }) => {
  const { t } = useTranslation();

  return (
    <Box width={250}>
      <Card
        sx={{
          marginBottom: 2,
          padding: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: 100,
          borderColor: "success.main",
          borderWidth: 2,
          borderStyle: "solid",
          backgroundColor: "rgba(76, 175, 80, 0.1)",
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{ alignSelf: "flex-start", color: "success.main" }}
        >
          {t("GPA")}
        </Typography>
        <Typography
          variant="h3"
          component="div"
          sx={{ alignSelf: "flex-start", color: "success.main" }}
        >
          {amount}
        </Typography>
      </Card>
    </Box>
  );
};

export default CardSummaryGpa;
